import { useIntl } from 'react-intl';
import { Row } from '@tanstack/react-table';

interface Props<T> {
  row: Row<T>;
}

export default function ExpandButton<T>({ row }: Props<T>) {
  const intl = useIntl();

  return (
    <button
      type="button"
      onClick={row.getToggleExpandedHandler()}
      className="p-1 rounded hover:bg-slate-100 transition-colors"
      aria-expanded={row.getIsExpanded()}
      aria-label={intl.formatMessage({ id: 'accounts.table.expand' })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`h-4 w-4 text-slate-400 transition-transform ${row.getIsExpanded() ? 'rotate-90' : ''}`}
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
}
